import { configureStore } from '@reduxjs/toolkit';
import datosReducer from './slice';

export default configureStore({
  reducer: {
    datos: datosReducer,
  },
});